export default "__VITE_ASSET__cK4aWFXQ__"